import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addRateFailure,
  addRateSuccess,
  deleteRateFailure,
  //
  deleteRateSuccess,
  editRateFailure,
  //
  editRateSuccess,
  fetchRatesFailure,
  //
  fetchRatesSuccess,
  //
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_RATE,
  DELETE_RATE,
  EDIT_RATE,
  FETCH_RATES,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchRatesSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee-hourly-rate?${query}`,
    );
    yield put(fetchRatesSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchRatesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching rate list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/hourly-rate/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching rate data!"));
  }
}

export function* addRateSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee-hourly-rate/add`,
      payload,
    );
    if (data) {
      yield put(successAlert("Wage updated successfully!"));
      yield put(addRateSuccess());
      typeof onSuccess === "function" && onSuccess(data);
    }
  } catch (e) {
    yield put(addRateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editRateSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/hourly-rate/update/${payload.id}`,
      payload,
    );
    if (data) {
      yield put(successAlert("Rate updated successfully!"));
      yield put(editRateSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(editRateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteRateSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/hourly-rate/${payload}`);
    if (data) {
      yield put(successAlert("Rate deleted successfully!"));
      yield put(deleteRateSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteRateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchRatesFlow() {
  yield takeEvery(FETCH_RATES, fetchRatesSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addRateFlow() {
  yield takeEvery(ADD_RATE, addRateSaga);
}
export function* editRateFlow() {
  yield takeEvery(EDIT_RATE, editRateSaga);
}
export function* deleteRateFlow() {
  yield takeEvery(DELETE_RATE, deleteRateSaga);
}

export default function* HourlyRateSaga() {
  yield all([
    fetchRatesFlow(),
    addRateFlow(),
    editRateFlow(),
    deleteRateFlow(),
    getViewDataFlow(),
  ]);
}
